<section class="bg-(--color-secondary) py-10">
  <div class="max-w-6xl mx-auto px-6">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-5">
      <!-- Card 1 -->
      <div class="vision-card p-6 text-white">
        <div class="card-img mb-6">
          <img
            src="/images/about-vision-right.png"
            alt="About Vision"
            class="w-full rounded-2xl object-cover"
          />
        </div>

        <h3 class="text-(--main-color) text-2xl font-bold mb-4 text-right">رسالتنا</h3>

        <div class="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-5 text-lg leading-9">
          <div class="space-y-5">
            <p>
              <span class="font-bold">1-</span>
              توفير فرص تعاقد زراعية مضمونة وشفافة لشريحة واسعة من المتعاقدين.
            </p>

            <p>
              <span class="font-bold">3-</span>
              دعم المزارعين وأصحاب المشاريع الزراعية بالتمويل والخبرة والتكنولوجيا.
            </p>

            <p>
              <span class="font-bold">5-</span>
              تطبيق ممارسات الزراعة المستدامة والحفاظ على الموارد الطبيعية.
            </p>
          </div>

          <div class="space-y-5">
            <p>
              <span class="font-bold">2-</span>
              نشر الوعي الزراعي والمالي بين المتعاقدين، وتأهيلهم لاتخاذ قرارات مدروسة.
            </p>

            <p>
              <span class="font-bold">4-</span>
              المساهمة في تحقيق الأمن الغذائي ودعم الاقتصاد الزراعي المصري.
            </p>
          </div>
        </div>
      </div>

      <!-- Card 2 -->
      <div class="vision-card p-6 text-white">
        <div class="card-img mb-6">
          <img
            src="/images/about-vision-left.png"
            alt="About Vision"
            class="w-full rounded-2xl object-cover"
          />
        </div>

        <h3 class="text-(--main-color) text-2xl font-bold mb-4 text-right">رؤيتنا</h3>

        <p class="text-lg leading-9 font-normal text-center md:text-right">
          أن نكون المنصة الأولى والأكثر ثقة للتعاقد الزراعي في مصر والمنطقة العربية، ونساهم في بناء
          قطاع زراعي حديث ومستدام يُلبّي احتياجات الحاضر دون المساس بحق الأجيال القادمة.
        </p>
      </div>
    </div>
  </div>
</section>
